import { useMutation } from "react-query";
import axios, { AxiosError } from "axios";
import { IUpdateEmployeesBlockedDate } from "../../@types/blockedDates";

const UpdateEmployeesBlockedDates = async (
  request: IUpdateEmployeesBlockedDate
): Promise<void> => {
  const url = "/odp_limits/employee/rules/blocked_dates/";
  const { data } = await axios.put(url, request);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useUpdateEmployeesBlockedDates = () =>
  useMutation<void, AxiosError, any>(UpdateEmployeesBlockedDates, {
    mutationKey: "UpdateEmployeesBlockedDates",
  });

export default useUpdateEmployeesBlockedDates;
